<main class="p-4 container-lg">
  <div class="row">
    <div class="col-12">
      <h2>Register</h2>
      <form [formGroup]="registerForm">
        <div class="form-group row mb-3">
          <div class="col-12 col-lg-6">
            <label for="firstName" class="form-label">First Name</label>
            <input type="text" class="form-control" placeholder="John" formControlName="firstName" />
            <div class="text-danger" *ngIf="(registerFormControl.firstName.touched || submitted) && registerFormControl.firstName.errors?.required">
              First name is required
            </div>
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col-12 col-lg-6">
            <label for="lastName" class="form-label">Last Name</label>
            <input type="text" class="form-control" placeholder="Doe" formControlName="lastName" />
            <div class="text-danger" *ngIf="(registerFormControl.lastName.touched || submitted) && registerFormControl.lastName.errors?.required">
              Last name is required
            </div>
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col-12 col-lg-6">
            <label for="email" class="form-label">Email</label>
            <input type="text" class="form-control" placeholder="user@email.com" formControlName="email">
            <div class="text-danger" *ngIf="(registerFormControl.email.touched || submitted) && registerFormControl.email.errors?.required">
              Email is required
            </div>
            <div class="text-danger" *ngIf="(registerFormControl.email.touched || submitted) && registerFormControl.email.errors?.email">
              Must be a valid email
            </div>
            <div class="text-danger" *ngIf="emailInUse">
              {{errors.DuplicateUserName}}
            </div>
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col-12 col-lg-6">
            <label for="password" class="form-label">Password</label>
            <input type="password" class="form-control" formControlName="password">
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col-12 col-lg-6">
            <label for="confirmPassword" class="form-label">Confirm Password</label>
            <input type="password" class="form-control" formControlName="confirmPassword">
            <div class="text-danger" *ngIf="registerFormControl.password.touched && registerFormControl.confirmPassword.touched && registerForm.errors?.PasswordNoMatch">
              Passwords do not match.
            </div>
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col-12 col-lg-6">
            <div class="form-check fs-4">
              <input type="checkbox" class="form-check-input" formControlName="includeAIEngineer" />
              <label for="includeAIEngineer" class="form-check-label">
                Include AI Engineer Subscription for ${{ getProductPrice('AIEngineer') }}/month
              </label>
            </div>
            <p>Chat with an AI Engineer to get tuning suggestions.</p>
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col-12 col-lg-6">
            <h5>Terms of Use</h5>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" formControlName="tosAgree">
              <label class="form-check-label" for="tosAgree">
                I Accept and agree to the <a href="/assets/media/GTProTuneTermsOfService.pdf" target="_blank">Terms of Service</a>
              </label>
            </div>
          </div>
        </div>

        <div class="row mb-3 d-flex">
          <div class="col-12 col-lg-4 d-lg-flex flex-grow-1 mb-3">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">7-Day Trial</h4>
                <p class="card-text">
                  Try out the GT Pro Tune before you commit to a buying. Some features will be limited for the duration of the trial.
                  The trial version includes all of the features of the Lite version and Advanced version.
                </p>


              </div>
              <div class="card-footer">
                <h2 class="text-center">Cost: Free</h2>
                <div class="form-group row">
                  <div class="col text-center">
                    <!--<input class="form-check-input" style="height: 50px; width: 50px;" type="radio" checked="checked" value="Trial" formControlName="subscriptionLevel" />-->
                    <button type="submit" class="btn btn-primary" (click)="register('Trial')" [disabled]="submitted">
                      <i class="fa-solid fa-lock" [class]="{
                         'fa-lock': !submitted || selectedSubscriptionLevel != 'Trial',
                         'fa-spinner': submitted && selectedSubscriptionLevel == 'Trial',
                         'fa-spin': submitted && selectedSubscriptionLevel == 'Trial'
                         }"></i> Start Free Trial
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-4 d-lg-flex flex-grow-1 mb-3">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Lite</h4>
                <p class="card-text">
                  Tune your suspsension and transmission with a simplifier set of of features.
                </p>

                <h5>Features</h5>
                <ul>
                  <li>Full suspension tuning</li>
                  <li>Basic transmisssion tuning</li>
                  <li>Shift points graph</li>
                  <li>Save/load settings</li>
                </ul>

              </div>
              <div class="card-footer">
                <h2 class="text-center">Cost: ${{ getProductPrice('Lite') }}</h2>
                <div class="form-group row">
                  <div class="col text-center">
                    <!--<input class="form-check-input" style="height: 50px; width: 50px;" type="radio" checked="checked" value="Lite" formControlName="subscriptionLevel" />-->
                    <button type="submit" class="btn btn-primary" (click)="register('Lite')" [disabled]="submitted">
                      <i class="fa-solid fa-lock" [class]="{
                         'fa-lock': !submitted || selectedSubscriptionLevel != 'Lite',
                         'fa-spinner': submitted && selectedSubscriptionLevel == 'Lite',
                         'fa-spin': submitted && selectedSubscriptionLevel == 'Lite'
                         }"></i> Buy Now!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-4 d-lg-flex flex-grow-1 mb-3">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Advanced</h4>
                <p class="card-text">
                  Tune your suspsension and transmission with an advanced set of of features. Utilize each car's torque curve
                  for precision gear tuning.
                </p>

                <h5>Features</h5>
                <ul>
                  <li>Full suspension tuning</li>
                  <li>Advanced transmisssion tuning</li>
                  <li>Torque/power graph</li>
                  <li>Shift points graph</li>
                  <li>Tractive graph</li>
                  <li>Save/load settings</li>
                </ul>

              </div>
              <div class="card-footer">
                <h2 class="text-center">Cost: ${{ getProductPrice('Advanced') }}</h2>
                <div class="form-group row">
                  <div class="col text-center">
                    <!--<input class="form-check-input" style="height: 50px; width: 50px;" type="radio" checked="checked" value="Advanced" formControlName="subscriptionLevel" />-->
                    <button type="submit" class="btn btn-primary" (click)="register('Advanced')" [disabled]="submitted">
                      <i class="fa-solid fa-lock" [class]="{
                         'fa-lock': !submitted || selectedSubscriptionLevel != 'Advanced',
                         'fa-spinner': submitted && selectedSubscriptionLevel == 'Advanced',
                         'fa-spin': submitted && selectedSubscriptionLevel == 'Advanced'
                         }"></i> Buy Now!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <a routerLink="/login" class="btn btn-outline-primary ms-2" [class]="{'disabled': submitted}">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</main>
